import React, { forwardRef } from 'react';

import { RadioButton } from 'primereact/radiobutton';
import { classNames } from 'primereact/utils';
import { GroupedAddon } from './GroupedAddon';

export const GroupTitledRadioButton = forwardRef((props, ref) => {
  const {
    name,
    title = '',
    value,
    items = [],
    onChange,
    error,
    disabled = false,
    readOnly = false,
    classNameProps,
    variant,
  } = props;

  return (
    <div className={classNames('p-inputgroup h-full', { 'p-error': error })}>
      <GroupedAddon
        title={title}
        variant={variant}
        classNameProps={classNameProps}
      />
      <div
        className={classNames(
          'cm-grouped-body p-inputgroup-addon bg-transparent h-full',
          { 'bg-gray-100': disabled }
        )}
      >
        {items.map((item, idx) => (
          <div key={`${name}_${idx}`}>
            <div className="flex flex-auto align-items-center justify-content-start gap-1">
              <RadioButton
                inputRef={ref}
                inputId={`trb_${props.id || name}_${idx}`}
                name={name}
                value={item.value}
                onChange={(e) => onChange(e.value)}
                checked={value === item.value}
                disabled={disabled}
                readOnly={readOnly}
              />
              <label
                className={item.labelColor}
                htmlFor={`trb_${props.id || name}_${idx}`}
              >
                {item.label}
              </label>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
});

GroupTitledRadioButton.displayName = 'GroupTitledRadioButton';
